/* import __COLOCATED_TEMPLATE__ from './container.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();